import { useState, useEffect } from 'react';
import { usePinLookup } from '../common/usePinLookup';
import Select from 'react-select';

function PincodeSelector({ form, setForm, stepSubmitted, name = 'pin_code', populate = true }) {
  const { pincodeSuggestions, fetchByPincode, loading } = usePinLookup();
  const [input, setInput] = useState(form.pin_code);

  const options = pincodeSuggestions.map(po => ({
    label: `${po.Pincode} - ${po.Name}, ${po.District}, ${po.State}`,
    value: po.Pincode,
    town: po.Name,
    city: po.District,
    state: po.State,
    pincode: po.Pincode
  }));

const [lastFetchedPin, setLastFetchedPin] = useState(null);

useEffect(() => {
  if (form.pin_code?.length === 6 && form.pin_code !== lastFetchedPin) {
    setLastFetchedPin(form.pin_code);
    fetchByPincode(form.pin_code);
  }
}, [form.pin_code, lastFetchedPin, fetchByPincode]);

  return (
    <Select
      isLoading={loading}
      inputValue={input}
      onInputChange={val => {
        setInput(val);
        if (val.length >= 3) fetchByPincode(val);
      }}
      options={options}
      onChange={opt => {
        setForm(prev => ({
          ...prev,
          town: opt.town,
          city: opt.city,
          state: opt.state,
          pin_code: opt.pincode
        }));
      }}
      placeholder="Search pincode..."
      noOptionsMessage={() => 'Type at least 3 digits'}
      classNamePrefix="react-select"
      className={stepSubmitted && !form.pin_code ? 'is-invalid' : ''}
    />
  );
}

export default PincodeSelector;
